import { useWatch } from "react-hook-form";
import useSchedulePricing from "../hooks/useSchedulePricing";

const PriceSummary = ({ control, voucherValid, btn, children }) => {

  const schedules = useWatch({
    control,
    name: "schedules"
  }) || [];

  const {
    originalTotal,
    discountedTotal,
    priceSummaryUI
  } = useSchedulePricing(schedules, voucherValid);
  // console.log(JSON.stringify(schedules, null, 2));
  return (
    <div className="order bg-white rounded shadow-sm sticky-sm-top mb-lg-4">

      {/* ORDER DETAILS */}
      <div>
        <p className="mb-1"><strong>Order Details:</strong></p>

        <div className="text-muted">
          {priceSummaryUI.map((detail, i) => (
            <div key={i} className="mb-2">
              <div className="d-flex justify-content-between">
                <p className="mb-0">
                  <strong>{`${detail.scheduleName} `}</strong>
                  {detail.packageType} – {detail.cityCount}
                </p>
                <p className="text-danger mb-0">
                  AUD {detail.price.toLocaleString('id-ID')}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <hr />
      {/* TOTAL */}
      <div>
        <div className="text-end">
          {voucherValid && (
            <h6 className="text-muted text-decoration-line-through">
              AUD {originalTotal.toLocaleString('id-ID')}
            </h6>
          )}
        </div>
        <div className="d-flex justify-content-between">
          <p className="mb-0"><strong>Total Price</strong></p>
          <h6 className="text-danger mb-0">
            AUD {discountedTotal.toLocaleString('id-ID')}
          </h6>
        </div>
      </div>

      {/* CONFIRMATION SECTION */}
      {children && <div className="mt-3">{children}</div>}

      {/* SUBMIT */}
      <div className="mt-3">
        <button
          type="submit"
          className="w-100 btn3 btn-danger btn-lg"
          disabled={btn}
        >
          {btn ? "Loading..." : "Submit"}
        </button>
      </div>

      <div className="pt-3">
        <p className="text-xs mb-0">Participant fee must be transferred to: <br />
          <strong>OCBC NISP, BRANCH TEUKU UMAR DENPASAR BALI</strong>
        </p>
        <p className="text-xs">Account Name: CV Naresy Indonesia <br />
          Account Number :160800014310 <br />
          Swift Code: NISPIDJA <br />
          Branch Code: 07160 <br />
          Bank Code: 028
        </p>
      </div>

    </div>
  );
};

export default PriceSummary;